<ng-template #dialogTemplate>
  <mat-dialog-content>
    {{ message }}
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false" class="gl-mar-r16">
      {{ cancelText }}
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      {{ confirmText }}
    </button>
  </mat-dialog-actions>
</ng-template>
